import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Form, Icon, Input, Button, Checkbox, Switch, Alert } from 'antd';
import Card, { TitleCard } from '../../core/Card'

import PersonalInfo from './PersonalInfo'
import CommunicationPrefs from './CommunicationPrefs'
import ChangePassword from './ChangePassword'

import './Profile.css'

export const Profile = () =>
  <div className="Profile">

    <TitleCard>
      <h1>Profile Settings</h1>
      <div/>
    </TitleCard>

    <PersonalInfo/>

    <ChangePassword/>

    <CommunicationPrefs/>
  </div>

export default Profile



// WEBPACK FOOTER //
// ./src/account/profile/Profile.jsx